import React, { useEffect, useState } from "react"
import dayjs from "dayjs"
import PropTypes from "prop-types"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import {StyledDatePicker} from "./Input.styled"

const DatePickerSelectV2 = (props) => {
    const [date, setDate] = useState(dayjs())

    useEffect(() => {
        if (props.value && dayjs(props.value).isValid()) setDate(dayjs(props.value))
        else setDate(dayjs())
    }, [props.value])

    const changeDate = (value) => {
        setDate(value)
        props.onChange(value)
    }

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                label={props.label || "Data"}
                value={date}
                format="DD/MM/YYYY"
                onChange={changeDate}
                slots={{ textField: StyledDatePicker }}
                slotProps={{
                    textField: {
                        variant: "filled",
                        fullWidth: true,
                    },
                }}
            />
        </LocalizationProvider>
    )
}

DatePickerSelectV2.propTypes = {
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
}

export default DatePickerSelectV2